import { render, staticRenderFns } from "./AppIntroduction.vue?vue&type=template&id=2992c973&scoped=true&"
var script = {}
import style0 from "./AppIntroduction.vue?vue&type=style&index=0&id=2992c973&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2992c973",
  null
  
)

export default component.exports